import React from 'react';
import Form from './Form';

import './styles.css';

export default function Forms() {
  return (
    <Form />
  );
}
